import { ListEntityType } from '../../lists';
import { IActionHandleListParams } from '../ActionHandleListBasic';
import {
  normalizeCommonFields,
  createActualBlockName,
  ActualNameCreator
} from '../common';
import { IRootStore } from '../../store/rootStore';

import { ActionAddToListNormalizer } from './client';

const createActionAddUserToListActualNameBase = ({
  rootStore,
  listId
}: {
  listId: string | null;
  rootStore: IRootStore;
}): string => {
  if (!listId) {
    return '';
  }

  const list = rootStore.listsStore.getList({
    lType: ListEntityType.users
  });
  const entity = list.entities[listId];
  return entity ? `Добавить в список «${entity.title}»` : '';
};

export const createActionAddUserToListActualName: ActualNameCreator<
  IActionHandleListParams
> = ({ params, rootStore }) =>
  createActionAddUserToListActualNameBase({ rootStore, listId: params.listId });

export const normalizeActionAddToList: ActionAddToListNormalizer = (
  raw,
  stores
) => {
  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionAddUserToListActualNameBase({
          rootStore: stores.rootStore,
          listId: raw.params.list_id
        }),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
